import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

import {
	Nds3LayoutDirective,
	AnimatedIfDirective,
	ApiurlPipe,
	AppLoadingDirective,
	BootstrapValidityDirective,
	CentsToEurosPipe,
	ConfirmModal,
	DisableControlDirective,
	EmptyOrValuePipe,
	FastCentsPipe,
	FocusDirective,
	HourMinutesPipe,
	LoaderModal,
	LoadingComponent,
	AutocompleteDropdownComponent,
	SearchableSelectComponent,
	ReplacePipe,
	SafeHtmlPipe,
	SafeUrlPipe,
	ToLocaleStringPipe,
	TtDirective,
	TtPipe,
	UiVersionSwitchComponent,
	ConfirmDialogComponent,
} from './shared';

@NgModule({
	declarations    : [
		Nds3LayoutDirective,
		TtDirective,
		FocusDirective,
		DisableControlDirective,
		BootstrapValidityDirective,
		AppLoadingDirective,
		LoadingComponent,
		LoaderModal,
		AnimatedIfDirective,
		ConfirmModal,
		TtPipe,

		ApiurlPipe,
		CentsToEurosPipe,
		FastCentsPipe,
		EmptyOrValuePipe,
		SafeHtmlPipe,
		SafeUrlPipe,
		ToLocaleStringPipe,
		ReplacePipe,
		HourMinutesPipe,

		AutocompleteDropdownComponent,
		SearchableSelectComponent,
		UiVersionSwitchComponent,
		ConfirmDialogComponent,
	],
	imports         : [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatSelectModule,
		MatOptionModule,
		MatIconModule,
		MatDialogModule,
		MatButtonModule,
		NgxMatSelectSearchModule
	],
	exports         : [
		Nds3LayoutDirective,
		TtDirective,
		FocusDirective,
		DisableControlDirective,
		BootstrapValidityDirective,
		AppLoadingDirective,
		LoadingComponent,
		AutocompleteDropdownComponent,
		SearchableSelectComponent,
		UiVersionSwitchComponent,
		ConfirmDialogComponent,
		LoaderModal,
		AnimatedIfDirective,
		ConfirmModal,

		TtPipe,
		ApiurlPipe,
		CentsToEurosPipe,
		FastCentsPipe,
		EmptyOrValuePipe,
		SafeHtmlPipe,
		SafeUrlPipe,
		ToLocaleStringPipe,
		ReplacePipe,
		HourMinutesPipe,

		ReactiveFormsModule,
		MatSelectModule,
		MatOptionModule,
		NgxMatSelectSearchModule,
		MatIconModule
	]
})
export class BaseImportModule {
}
